import { create } from 'zustand'

export type ComposerBridgeActions = {
    insertText: (text: string, embeds?: string[]) => void
}

type ComposerBridgeState = {
    actions: ComposerBridgeActions | null
    setActions: (actions: ComposerBridgeActions | null) => void
}

const useComposerBridgeStore = create<ComposerBridgeState>((set) => ({
    actions: null,
    setActions: (actions) => set({ actions }),
}))

export const useComposerBridge = () => useComposerBridgeStore((state) => state.actions)

export const setComposerBridgeActions = (actions: ComposerBridgeActions | null) => {
    useComposerBridgeStore.getState().setActions(actions)
}

export const clearComposerBridgeActions = (actions: ComposerBridgeActions) => {
    const current = useComposerBridgeStore.getState().actions
    if (current === actions) {
        useComposerBridgeStore.getState().setActions(null)
    }
}
